import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import parse from 'html-react-parser';

import useGetWealthDeclarations from '../../../hooks/useGetWealthDeclarations/useGetWealthDeclarations';
import useSetPageTitle from '../../../hooks/useSetPageTitle/useSetPageTitle';

import PageBanner from '../../../common/PageBanner/PageBanner';
import Spinner from '../../../components/Spinner/Spinner';

import { DEFAULT_IMAGE_ALT_TEXT } from '../../../config/constants/contants';

import { TDeclaration } from '../../../types/TGetWealthDeclarationsResponse';

import bannerImage from '../../../images/vitralii-new.webp';

import styles from './WealthDeclaration.module.scss';
import commons from '../../../shared/styles/common.module.scss';

const WealthDeclaration = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetWealthDeclarations();

  useSetPageTitle({
    pageTitle: `${t('pages.wealth-declarations')} - ${t(
      'general.website-name',
    )}`,
  });

  React.useEffect(() => {
    if (data) {
      const linksSelectors = document
        .getElementById('wealth-declarations')
        ?.querySelectorAll('ul li ul li');

      linksSelectors?.forEach((selector) => {
        const iElement = document.createElement('i');
        iElement.className = 'fas fa-external-link';
        iElement.style.fontSize = 'var(--font-size-sm)';
        iElement.style.paddingLeft = 'var(--spacing-4)';
        selector.appendChild(iElement);
      });
    }
  }, [data]);

  return (
    <div>
      <PageBanner
        imageSrc={bannerImage}
        imageText={DEFAULT_IMAGE_ALT_TEXT}
        title={t('pages.wealth-declarations')}
      />
      <div
        className={classNames(styles.content, commons.container)}
        id='wealth-declarations'>
        {isLoading ? (
          <Spinner variant='green' />
        ) : (
          data?.map((item: TDeclaration) => (
            <>
              <h1 className={styles.contentTitle}>{item.title}</h1>
              <div className={styles.contentValue}>{parse(item.content)}</div>
            </>
          ))
        )}
      </div>
    </div>
  );
};

export default WealthDeclaration;
